import React from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import icToTop from 'assets/img/ic_to-top.png';

const ScrollDesktop = ({
  isHidden,
  onClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, !isHidden && styles.active)
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.btn,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.lightBorder
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.circle
  }, /*#__PURE__*/React.createElement("img", {
    src: icToTop,
    alt: "Stake Now"
  })), /*#__PURE__*/React.createElement("span", null, "Stake Now")));
};

export default ScrollDesktop;